import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-eon-ui-icon-button-custom',
  templateUrl: './eon-ui-icon-button-custom.component.html',
  styleUrls: ['./eon-ui-icon-button-custom.component.scss']
})
export class EonUiIconButtonCustomComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
